export const playerProfileLinkingScreens = {
  PlayerProfile: 'profile/:username?',
} as const;
